import { watch } from 'vue'
import type { Ref } from 'vue'

/**
 * Composable qui pré-remplit le champ ville à partir d'un code postal français.
 * Utilise l'API publique https://geo.api.gouv.fr (sans clé, sans quota).
 *
 * @param postalCode - Ref du code postal à surveiller
 * @param onCityFound - Callback appelé avec le nom de la ville trouvée
 */
export function usePostalCode(postalCode: Readonly<Ref<string | null |undefined>>, onCityFound: (city: string) => void) {

  watch(postalCode, async (value) => {

    if (!value || !/^\d{5,}$/.test(value)) { //Au moins 5 chiffres pour éviter les appels API inutiles
      return
    }

    try {
        const response = await fetch(
          `https://geo.api.gouv.fr/communes?codePostal=${value}&fields=nom&format=json`
        )
        if (!response.ok) return
        else
        {
          const communes: { nom: string }[] = await response.json()
          if (communes.length > 0) {
            onCityFound(communes[0].nom) // On prend la première commune trouvée
          }
        }
      } catch {
        // Silencieux — on ne bloque pas la saisie manuelle en cas d'erreur réseau
      }
  })
}
